export default "__VITE_PUBLIC_ASSET__f1c1e2d3__"